import { render } from "./ProcessTranslation.vue?vue&type=template&id=46e15ef8&scoped=true"
import script from "./ProcessTranslation.vue?vue&type=script&lang=js"
export * from "./ProcessTranslation.vue?vue&type=script&lang=js"

import "./ProcessTranslation.vue?vue&type=style&index=0&id=46e15ef8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46e15ef8"]])

export default __exports__